import React from "react";
import { Switch, Route } from "react-router-dom";
import TopPage from "pages/TopPage";
import CompanyDetailPage from "pages/CompanyDetailPage";
import WorkDetailPage from "pages/WorkDetailPage";

export const paths = {
  top: "/",
  company: "/companies/:id",
  work: "/works/:id",
};

export default () => {
  return (
    <Switch>
      <Route path={paths.company}>
        <CompanyDetailPage />
      </Route>
      <Route path={paths.work}>
        <WorkDetailPage />
      </Route>
      <Route path={paths.top}>
        <TopPage />
      </Route>
    </Switch>
  );
};
